import { default as dayjs } from 'dayjs';
import PropTypes from 'prop-types';

export const formatDate = (date) => dayjs(date).format('MMMM D, YYYY');

export const removePlusPrefix = (phone) => {
  if (!phone) return '';
  return phone.startsWith('+') ? phone.substring(1) : phone;
};

formatDate.propTypes = {
  date: PropTypes.string.isRequired,
};
